module.exports = __webpack_public_path__ + "static/how-it-works-step-2-29d703ddd79ba6421dda846c8f0bb867.png";